import { ComboboxItem, Select as MantineSelect, SelectProps as MantineSelectProps } from '@mantine/core';
import { useCallback, useMemo, useRef, useState } from 'react';

interface SelectProps extends MantineSelectProps {
  'data-pw'?: string;
}

export const Select: React.FC<SelectProps> = (props) => {
  const [focused, setFocused] = useState(false);
  const selectRef = useRef<HTMLInputElement>(null);

  const floating = useMemo(() => {
    if (typeof props.value === 'string') {
      return props.value.trim().length !== 0 || focused ? true : undefined;
    }

    if (typeof props.value === 'number') {
      return !Number.isNaN(props.value) ? true : undefined;
    }

    return focused || undefined;
  }, [props.value, focused]);

  const handleFocus = (evt: React.FocusEvent<HTMLInputElement>) => {
    setFocused(true);
    props.onFocus?.(evt);
  };

  const handleBlur = (evt: React.FocusEvent<HTMLInputElement>) => {
    setFocused(false);
    props.onBlur?.(evt);
  };

  const handleChange = useCallback(
    (value: string | null, option: ComboboxItem) => {
      if (props.onChange) {
        props.onChange(value, option);
      }

      if (selectRef.current) {
        selectRef.current.blur();
      }
    },
    [props.onChange],
  );

  return (
    <MantineSelect
      ref={selectRef}
      data-pw={props['data-pw']}
      {...props}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur}
      autoComplete="nope"
      data-floating={floating}
      labelProps={{ ...props.labelProps, 'data-floating': floating, 'data-error': props.error }}
    />
  );
};
